<!--==================================================
    component name  : 導覽列
    author          : Samma
    last update     : 2020-05-05
    use description : 
==================================================-->
<template>
  <div class="orangelinebg orangelinebg-top">
    <!--品牌 LOGO-->
    <div class="orangelinelogo">
      <router-link to="/">
        <div class="logo"></div>
      </router-link>
    </div>

    <!--導覽列-->
    <div class="nav owlnav">
      <!--導覽列(一般模式)-->
      <ul class="d-none d-xl-block">
        <li v-for="page in pages" v-bind:key="page.id">
          <router-link
            :to="page.path"
            v-bind:class="{
              active: page.is_current,
              'hvr-underline-from-center': !page.is_current,
            }"
            >{{ $t(page.item_name) }}</router-link
          >
        </li>
      </ul>

      <!--語系切換鈕(一般模式)-->
      <LangBtns type="content"></LangBtns>

      <!--導覽列(手機模式-漢堡選單)-->
      <div
        class="navbutton d-xl-none"
        @click="mobile_nav_open = !mobile_nav_open"
      >
        <div class="lineall" :class="{ show: mobile_nav_open }">
          <div class="line1"></div>
          <div class="line2"></div>
        </div>
      </div>

      <!--語系切換鈕(手機模式)-->
      <LangBtns type="mobile" ref="lang_menu"></LangBtns>

      <!--導覽列(手機模式)-->
      <div class="navopenbg d-xl-none" :class="{ show: mobile_nav_open }">
        <ul>
          <li v-for="page in pages" v-bind:key="page.id">
            <router-link :to="page.path">{{ $t(page.item_name) }}</router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import LangBtns from '@/components/LangBtns.vue';

export default {
  name: 'NavBtns',
  components: {
    LangBtns,
  },
  data: function () {
    return {
      mobile_nav_open: false,
      //官網頁面
      pages: [
        {
          id: 1,
          path: '/feature',
          item_name: 'message.nav_feature',
          is_current: false,
        },
        {
          id: 2,
          path: '/querysite',
          item_name: 'message.nav_querysite',
          is_current: false,
        },
        {
          id: 3,
          path: '/location',
          item_name: 'message.nav_location',
          is_current: false,
        },
        {
          id: 4,
          path: '/about',
          item_name: 'message.nav_about',
          is_current: false,
        },
        {
          id: 5,
          path: '/news',
          item_name: 'message.nav_news',
          is_current: false,
        },
        {
          id: 6,
          path: '/operation',
          item_name: 'message.nav_operation',
          is_current: false,
        },
        {
          id: 7,
          path: '/contact',
          item_name: 'message.nav_contact',
          is_current: false,
        },
        {
          id: 8,
          path: '/faq',
          item_name: 'message.nav_faq',
          is_current: false,
        },
      ],
    };
  },
  mounted: function () {
    var current_path = this.$route.path;
    //標注當前頁面
    for (var i = 0; i < this.pages.length; i++) {
      if (this.pages[i].path == current_path) {
        this.pages[i].is_current = true;
      }
    }
  },
  methods: {},
  watch: {
    mobile_nav_open: function (new_val) {
      this.$refs.lang_menu.vToggleLangMenu(new_val);
    },
  },
};
</script>
